import React from 'react'
const altTexts = {
    shivaji: "Chhatrapati Shivaji Maharaj in regal attire, standing confidently with a sword at his side, set against the historic backdrop of Panhala Fort. The environment conveys a sense of pride and heroism, evoking the legacy and valor of the Maratha empire.",
    bajiPrabhu: "Baji Prabhu Deshpande depicted as a brave Maratha warrior, holding a weapon and ready for battle, with a determined expression. The background suggests a dramatic moment in history, highlighting sacrifice and loyalty during the escape at Pavankhind.",
    panhalaFort: "Panhala Fort with its massive stone walls, ancient gateways, and lush green surroundings under a bright sky. The scene feels majestic and tranquil, emphasizing the fort's historical significance and natural beauty."
};

export default function About (){
    return (
    <section id="about" className="content-section">
        <div className="container">
            <div className="row align-items-center">
                 <div className="col-lg-6 text-reveal about-intro">
                    <div className="section-badge fade-in-left"><i className="fas fa-compass"></i> Between History & Nature</div>
                    <h2 className="display-5 fw-bold mb-3 gradient-title title-underline fade-in-left">A Sanctuary Between History & Nature</h2>
                     <p className="lead mb-3 fade-in-left about-subtitle"><strong>Panhala Fort – Where History Meets Majesty</strong></p>
                     <p className="mb-4 fade-in-left about-paragraph">We all cherish a dream to paradise...to be in floating clouds,dancing moonbeams and misty mountains.<strong>Panhala</strong> is a beautiful nature escape with historical heritage.This place is for those who would rather rely on more modern methods of fitness like Jogging,Trekking and makes it a perfect holiday destination.</p>
                     <p className="mb-3 fade-in-left about-paragraph">Just a short distance from our hotel lies the iconic Panhala Fort, forever linked with <strong>Chhatrapati Shivaji Maharaj</strong>. Captured in 1659, this fort became a symbol of Maratha power and strategy. Panhala is also known as the best hill station standing 3200 feet above sea level with a very pleasant summer, misty climate in rainy season and cold in winter. This place so abundant in nature's bounty which makes it perfect place for meditation, yoga and naturopathy.</p>
                     <div className="row g-3">
                         <div className="col-12 col-md-4">
                             <div className="text-center about-feature">
                                 <div className="about-feature-icon"><i className="fas fa-mountain"></i></div>
                                 <h5 className="mt-3">Mountain Views</h5>
                             </div>
                         </div>
                         <div className="col-12 col-md-4">
                             <div className="text-center about-feature">
                                 <div className="about-feature-icon"><i className="fas fa-person-hiking"></i></div>
                                 <h5 className="mt-3">Nature Trails</h5>
                             </div>
                         </div>
                         <div className="col-12 col-md-4">
                             <div className="text-center about-feature">
                                 <div className="about-feature-icon"><i className="fas fa-chess-rook"></i></div>
                                 <h5 className="mt-3">Fort Heritage</h5>
                             </div>
                         </div>
                     </div>
                 </div>
                 <div className="col-lg-6">
                     <div id="aboutCarousel" className="carousel slide fade-in-right hover-lift" data-bs-ride="carousel" data-bs-interval="1500">
                         <div className="carousel-indicators">
                             <button type="button" data-bs-target="#aboutCarousel" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                             <button type="button" data-bs-target="#aboutCarousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
                             <button type="button" data-bs-target="#aboutCarousel" data-bs-slide-to="2" aria-label="Slide 3"></button>
                         </div>
                         <div className="carousel-inner rounded shadow-lg">
                             <div className="carousel-item active">
                                <img src="/Images/shivajimaharaj.jpeg" className="d-block w-100 img-fluid" alt={altTexts.shivaji} onError={e => {
                                   const steps = [
                                       '/Images/shivajimaharaj.jpeg',
                                       'https://via.placeholder.com/1200x800?text=Shivaji+Maharaj'
                                   ];
                                    let step = parseInt(e.target.dataset.step || '0', 10);
                                    if (step < steps.length) {
                                        e.target.src = steps[step];
                                        e.target.dataset.step = step + 1;
                                    }
                                 }}/>
                             </div>
                             <div className="carousel-item">
                                <img src="/Images/bajiprabhu_deshpande.jpeg" className="d-block w-100 img-fluid" alt={altTexts.bajiPrabhu} onError={e => {
                                   const steps = [
                                       '/Images/bajiprabhu_deshpande.jpeg',
                                       'https://via.placeholder.com/1200x800?text=Baji+Prabhu+Deshpande'
                                   ];
                                    let step = parseInt(e.target.dataset.step || '0', 10);
                                    if (step < steps.length) {
                                        e.target.src = steps[step];
                                        e.target.dataset.step = step + 1;
                                    }
                                 }}/>
                             </div>
                             <div className="carousel-item">
                                <img src="/Images/panhalafort.jpeg" className="d-block w-100 img-fluid" alt={altTexts.panhalaFort} onError={e => {
                                   const steps = [
                                       '/Images/panhalafort.jpeg',
                                       'https://via.placeholder.com/1200x800?text=panhalafort'
                                   ];
                                    let step = parseInt(e.target.dataset.step || '0', 10);
                                    if (step < steps.length) {
                                        e.target.src = steps[step];
                                        e.target.dataset.step = step + 1;
                                    }
                                 }}/>
                             </div>
                         </div>
                         <button className="carousel-control-prev" type="button" data-bs-target="#aboutCarousel" data-bs-slide="prev">
                             <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                             <span className="visually-hidden">Previous</span>
                         </button>
                         <button className="carousel-control-next" type="button" data-bs-target="#aboutCarousel" data-bs-slide="next">
                             <span className="carousel-control-next-icon" aria-hidden="true"></span>
                             <span className="visually-hidden">Next</span>
                         </button>
                     </div>
                 </div>
            </div>
        </div>
    </section>
    )
}